/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'confluence-analytics-chart.default-loading-text': 'Analysedaten werden aktualisiert …',
  'confluence-analytics-chart.tooltip.no-views-data': 'Keine Daten',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 Ansicht} other {{count} Ansichten}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 Ansicht bisher} other {{count} Ansichten bisher}}',
  'confuence-analytics-chart.accessible-table.caption': 'Seitenansichten',
  'confuence-analytics-chart.accessible-table.header.date': 'Datum',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Ansichten',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Keine Ansichten',
};
